(function(){
  var W = document.getElementById("stl-widget");
  if (!W) return;
  var handlesAttr = W.getAttribute("data-handles");
  if (!handlesAttr) return;
  var handles = handlesAttr.split(",");
  var products = [];
  var loaded = 0;

  handles.forEach(function(h, idx) {
    fetch("/products/" + h + ".js")
      .then(function(r) { return r.json(); })
      .then(function(p) { products[idx] = p; loaded++; if (loaded === handles.length) renderAll(); })
      .catch(function() { loaded++; if (loaded === handles.length) renderAll(); });
  });

  function getAvailableValues(p, optionIndex, selectedOpts) {
    var available = {};
    p.variants.forEach(function(v) {
      if (!v.available) return;
      var ok = true;
      selectedOpts.forEach(function(sel, si) {
        if (si === optionIndex) return;
        if (sel && v["option" + (si + 1)] !== sel) ok = false;
      });
      if (ok) available[v["option" + (optionIndex + 1)]] = true;
    });
    return available;
  }

  function findAutoSelections(p) {
    // Returns array of auto-selected values per option, or "" if multiple choices
    var auto = [];
    p.options.forEach(function(opt, oi) {
      if (opt.values.length <= 1 && opt.values[0] === "Default Title") {
        auto.push("__default__");
        return;
      }
      var emptyOpts = [];
      p.options.forEach(function() { emptyOpts.push(""); });
      var avail = getAvailableValues(p, oi, emptyOpts);
      var availKeys = Object.keys(avail);
      if (availKeys.length === 1) {
        auto.push(availKeys[0]); // only one choice — auto-select
      } else {
        auto.push(""); // multiple choices — customer must pick
      }
    });
    return auto;
  }

  function renderAll() {
    var c = document.getElementById("stl-products");
    if (!c) return;
    c.innerHTML = "";
    products.forEach(function(p, i) {
      if (!p) return;
      var autoSel = findAutoSelections(p);
      var d = document.createElement("div");
      d.id = "stl-card-" + i;
      d.style.cssText = "display:flex;gap:16px;padding:16px;background:#fff;border-radius:12px;border:2px solid #E5E7EB;align-items:center;flex-wrap:wrap;transition:border-color 0.2s";
      var img = p.images && p.images[0] ? p.images[0].replace(/\.jpg/, "_200x.jpg").replace(/\.png/, "_200x.png") : "";
      var ih = "";
      ih += "<div style='flex-shrink:0'><img src='" + img + "' style='width:80px;height:80px;object-fit:cover;border-radius:8px' alt='" + p.title + "'></div>";
      ih += "<div style='flex:1;min-width:150px'>";
      ih += "<div style='font-weight:600;font-size:15px;color:#1E293B'>" + p.title + "</div>";
      ih += "<div style='font-size:13px;color:#64748B'>" + p.vendor + "</div>";
      ih += "<div style='font-weight:600;color:#1E293B;margin-top:4px'>" + Math.round(p.price / 100) + " kr</div>";
      var selHTML = "<div style='display:flex;gap:8px;flex-wrap:wrap;margin-top:8px'>";
      var hasVisibleSelect = false;
      p.options.forEach(function(opt, oi) {
        if (opt.values.length <= 1 && opt.values[0] === "Default Title") return;
        var emptyOpts = [];
        p.options.forEach(function() { emptyOpts.push(""); });
        var avail = getAvailableValues(p, oi, emptyOpts);
        var availKeys = Object.keys(avail);

        if (availKeys.length === 1) {
          // Auto-selected — show as a tag, not a dropdown
          selHTML += "<span style='padding:8px 14px;background:#F0FDF4;color:#166534;border:1px solid #BBF7D0;border-radius:8px;font-size:14px;font-weight:500'>" + opt.name + ": " + availKeys[0] + " \u2713</span>";
        } else {
          hasVisibleSelect = true;
          selHTML += "<select data-pi='" + i + "' data-oi='" + oi + "' onchange='window.stlUpdateVariant(" + i + ")' ";
          selHTML += "style='padding:8px 12px;border:1px solid #D1D5DB;border-radius:8px;font-size:14px;background:#fff;min-width:80px;appearance:auto'>";
          selHTML += "<option value=''>" + opt.name + "</option>";
          opt.values.forEach(function(v) {
            if (avail[v]) {
              selHTML += "<option value='" + v + "'>" + v + "</option>";
            } else {
              selHTML += "<option value='" + v + "' disabled style='color:#ccc'>" + v + " \u2014 slutsåld</option>";
            }
          });
          selHTML += "</select>";
        }
      });
      selHTML += "</div>";
      ih += selHTML + "</div>";
      ih += "<input type='hidden' id='stl-vid-" + i + "' value=''>";
      d.innerHTML = ih;
      c.appendChild(d);

      // Auto-resolve variant if all options are determined
      var allDetermined = autoSel.every(function(a) { return a !== ""; });
      if (allDetermined) {
        var match = null;
        p.variants.forEach(function(v) {
          if (!v.available) return;
          var ok = true;
          autoSel.forEach(function(a, ai) {
            if (a === "__default__") return;
            if (v["option" + (ai + 1)] !== a) ok = false;
          });
          if (ok) match = v;
        });
        if (match) {
          document.getElementById("stl-vid-" + i).value = match.id;
          d.style.borderColor = "#22C55E";
        }
      }
    });
  }

  window.stlUpdateVariant = function(pi) {
    var p = products[pi];
    if (!p) return;
    var selects = document.querySelectorAll("select[data-pi='" + pi + "']");
    var opts = [];
    // Build full opts array including auto-selected values
    var autoSel = findAutoSelections(p);
    p.options.forEach(function(opt, oi) {
      if (autoSel[oi] && autoSel[oi] !== "") {
        opts.push(autoSel[oi] === "__default__" ? "" : autoSel[oi]);
      } else {
        // Find the select for this option
        var found = false;
        selects.forEach(function(s) {
          if (parseInt(s.getAttribute("data-oi")) === oi) {
            opts.push(s.value);
            found = true;
          }
        });
        if (!found) opts.push("");
      }
    });

    // Update availability on selects
    selects.forEach(function(s) {
      var oi = parseInt(s.getAttribute("data-oi"));
      var avail = getAvailableValues(p, oi, opts);
      var currentVal = s.value;
      var optObj = p.options[oi];
      s.innerHTML = "<option value=''>" + (optObj.name || "Välj") + "</option>";
      optObj.values.forEach(function(v) {
        if (avail[v]) {
          s.innerHTML += "<option value='" + v + "'" + (v === currentVal ? " selected" : "") + ">" + v + "</option>";
        } else {
          s.innerHTML += "<option value='" + v + "' disabled style='color:#ccc'>" + v + " \u2014 slutsåld</option>";
        }
      });
    });

    var hasEmpty = opts.some(function(o, oi) {
      if (autoSel[oi] === "__default__") return false;
      return !o;
    });

    if (hasEmpty) {
      document.getElementById("stl-vid-" + pi).value = "";
      var card = document.getElementById("stl-card-" + pi);
      if (card) card.style.borderColor = "#E5E7EB";
      return;
    }

    var match = null;
    p.variants.forEach(function(v) {
      var ok = true;
      opts.forEach(function(o, idx) {
        if (autoSel[idx] === "__default__") return;
        if (o && v["option" + (idx + 1)] !== o) ok = false;
      });
      if (ok && v.available) match = v;
    });
    var inp = document.getElementById("stl-vid-" + pi);
    inp.value = match ? match.id : "";
    var card = document.getElementById("stl-card-" + pi);
    if (card) {
      if (match) card.style.borderColor = "#22C55E";
      else card.style.borderColor = "#F59E0B";
    }
  };

  window.stlAddAll = function() {
    var items = [];
    var missing = [];
    products.forEach(function(p, i) {
      if (!p) return;
      var vid = document.getElementById("stl-vid-" + i);
      if (!vid || !vid.value) missing.push(p.title);
      else items.push({ id: parseInt(vid.value), quantity: 1 });
    });
    var errEl = document.getElementById("stl-error");
    if (missing.length > 0) {
      errEl.style.display = "block";
      errEl.textContent = "Välj storlek/färg för: " + missing.join(", ");
      return;
    }
    errEl.style.display = "none";
    var btn = document.getElementById("stl-add-btn");
    btn.textContent = "Lägger till...";
    btn.disabled = true;
    btn.style.background = "#64748B";
    fetch("/cart/add.js", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ items: items }) })
      .then(function(r) { return r.json(); })
      .then(function() { window.location = "/cart"; })
      .catch(function(e) {
        errEl.style.display = "block";
        errEl.textContent = "Något gick fel: " + e.message;
        btn.textContent = "Försök igen";
        btn.disabled = false;
        btn.style.background = "#1E293B";
      });
  };
})();
